const GA_MEASUREMENT_ID = "G-YPZQ0RRTP6";

let cachedClientId = null;

export function loadGoogleAnalytics() {
  if (window.gtag) return;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);
}

export function getGtagClientId() {
  return new Promise((resolve) => {
    if (cachedClientId) {
      resolve(cachedClientId);
      return;
    }

    if (!window.gtag) {
      resolve(null);
      return;
    }

    window.gtag("get", GA_MEASUREMENT_ID, "client_id", (clientId) => {
      cachedClientId = clientId;
      resolve(clientId);
    });
  });
}